import healthRoutes from './health/routes';
import mainRoutes from './main/routes';
import reviewsRoutes from './reviews/routes';
import widgetsRoutes from './widgets/routes';

export default {
  path: '/',
  // The order here is important. `mainRoutes` must go last to show a correct NotFoundPage.
  childRoutes: [...widgetsRoutes, ...healthRoutes, ...reviewsRoutes, ...mainRoutes],
};



// WEBPACK FOOTER //
// ./src/routes.js